'use strict';

import vertex from '../../threejs/Shaders/transition/transition_vertex.glsl';
import fragment from '../../threejs/Shaders/transition/transition_fragment.glsl';
import { DoubleSide, RawShaderMaterial } from 'three';
import { ShaderPass } from 'three/examples/jsm/postprocessing/ShaderPass';
import { Effect } from './Effect';

export class TransitionPass extends Effect{
  constructor () {
    super();
    const material = new RawShaderMaterial({
      vertexShader: vertex,
      fragmentShader: fragment,
      uniforms: {
        tDiffuse: { value: null },
        scale   : { value: 1.0  },
        opacity : { value: 0.0  },
      },
      side       : DoubleSide,
      depthTest  : false,
      depthWrite : false,
      transparent: true,
    });

    this.effect = new ShaderPass(material);
    this.effect.enabled = false;
  }

  set scale(value) {
    this.effect.uniforms.scale.value = value;
  }

  set opacity(value) {
    this.effect.uniforms.opacity.value = value;
  }

}
